import color from '@deprecated-ui/_style/color';
import SectionItem from './SectionItem';
import SectionList from './SectionList';

interface LastConnectedRoomsProps {
  selectedReceiverId: Array<number>;
  lastConnectedRooms: any[];
  onSelectReceiver: (receiver: any, id: number) => void;
  onClickMore: () => void;
}

function LastConnectedRooms({
  selectedReceiverId,
  lastConnectedRooms,
  onSelectReceiver,
  onClickMore,
}: LastConnectedRoomsProps) {
  return (
    <SectionList title="Send to">
      {lastConnectedRooms.map((room) => (
        <SectionItem
          key={room.id}
          src={room.avatar}
          caption={room.name}
          onClick={() => onSelectReceiver(room, room.id)}
          isAvatar
          selected={selectedReceiverId.includes(room.id)}
          data={room}
        />
      ))}
      <SectionItem
        background={color.snow}
        src="/icon/chevron-right-green.svg"
        caption="More"
        onClick={onClickMore}
        imageStyle={{
          width: 'auto',
          height: 'auto',
          minWidth: '20px',
          minHeight: '20px',
        }}
        bordered
      />
    </SectionList>
  );
}

export default LastConnectedRooms;
